import React from 'react';
import { inject } from 'mobx-react';
import { MainLayoutTemplate } from 'themes/layouts';

function MainLayout(props) {
	return <MainLayoutTemplate {...props} />;
}

export default inject(i => ({
	initialized: i.rootStore.appStore.initialized,
	routerStore: i.rootStore.routerStore,
	mainViewStore: i.rootStore.viewStore,
}))(MainLayout);



// WEBPACK FOOTER //
// ./src/core/layouts/MainLayout.jsx